import { PAYMENT_TYPES } from '../../constants';
import { PaymentService } from '../../types/paymentService';

export const createPaymentMethod =
  (activePaymentType: string) => (paymentMethod: PaymentService) => {
    const {
      name: defaultName,
      icon: defaultIcon,
      serviceId: systemServiceId,
      withdraw = {},
      carousel
    } = paymentMethod;

    const { name: withdrawName, icon: withdrawIcon } = withdraw;
    const isWithdrawPaymentType = activePaymentType === PAYMENT_TYPES.WITHDRAW;
    const name = (isWithdrawPaymentType && withdrawName) || defaultName;
    const icon = (isWithdrawPaymentType && withdrawIcon) || defaultIcon;
    const iconDark =
      (isWithdrawPaymentType && withdraw['icon-dark']) ||
      paymentMethod['icon-dark'] ||
      defaultIcon;

    return {
      name,
      icon,
      iconDark,
      serviceId: systemServiceId,
      carousel
    };
  };
